export const UserGroup = {
  Regular: 0,
  Admin: 1,
  Moderator: 2,
  Partner: 3,
  VIP: 4,
} as const;

export type UserGroupId = (typeof UserGroup)[keyof typeof UserGroup];
